import React, { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

/**
 * InfoTip — a question-mark icon with an INSTANT tooltip.
 *
 * Native `title` tooltips wait on a browser-controlled ~1-2s hover delay that
 * cannot be configured; this renders immediately on hover, via a fixed-position
 * portal so it never gets clipped by overflow containers (tables). Same
 * mechanism AssignedUsersBubbles uses.
 */
export function InfoTip({ text, className = 'w-3.5 h-3.5 text-white/60' }) {
  const [rect, setRect] = useState(null);

  const onEnter = useCallback((e) => setRect(e.currentTarget.getBoundingClientRect()), []);
  const onLeave = useCallback(() => setRect(null), []);

  return (
    <span
      className="inline-flex cursor-help"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      <QuestionMarkCircleIcon className={className} />
      {rect && createPortal(
        <div
          className="fixed px-2.5 py-1.5 text-[11px] font-normal normal-case tracking-normal leading-snug text-white bg-gray-800 rounded-lg max-w-[260px] text-left z-[9999] pointer-events-none shadow-lg"
          style={{
            top: rect.top - 6,
            left: Math.min(
              Math.max(rect.left + rect.width / 2, 140),
              window.innerWidth - 140
            ),
            transform: 'translate(-50%, -100%)',
          }}
        >
          {text}
        </div>,
        document.body
      )}
    </span>
  );
}

export default InfoTip;
